import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AlertNotice } from 'shared/components';
import { sumBy } from 'lodash';

const MaterialChainEvent = (props) => {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      {props.displayEventMaterials && (
        <div className="box material-chain-event">
          <div className="box-content">
            <div className="details">
              {!!props.eventMaterials?.length && props.materialTypes ? (
                props.eventMaterials.map(
                  (typeMaterials, materialTypeId) =>
                    typeMaterials &&
                    props.materialTypes[materialTypeId] && (
                      <div className="item" key={`event-material-${materialTypeId}`}>
                        <div className="item-content">
                          <div className="item-title">
                            {props.materialTypes[materialTypeId].name} (
                            {t('testCenter.testMaterials.usedOf', {
                              count: props.eventUsedMaterials[materialTypeId] || 0,
                              total: sumBy(typeMaterials, 'count'),
                            })}
                            )
                            {!props.eventUsedMaterials[materialTypeId] && (
                              <i className="fa fa-exclamation-triangle"></i>
                            )}
                          </div>
                          <div className="item-details">
                            <div>
                              {typeMaterials.map((material) => (
                                <span key={`event-range-${material.id}`}>
                                  {material.rangeBegin} - {material.rangeEnd} ({material.count})
                                </span>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                )
              ) : (
                <AlertNotice message={t('testCenter.testMaterials.noRangesEventMessage')} />
              )}
            </div>
            <div className="actions">
              {props.eventMaterials.length ? (
                <Link
                  to={`/test-event/${props.tcEventId}/test-materials/ranges`}
                  className="btn btn-outline btn-small">
                  {t('testCenter.testMaterials.editBtn')}
                </Link>
              ) : (
                <Link
                  to={`/test-event/${props.tcEventId}/test-materials/ranges`}
                  className="btn btn-primary btn-small">
                  {t('testCenter.testMaterials.addBtn')}
                </Link>
              )}
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

MaterialChainEvent.propTypes = {
  displayEventMaterials: PropTypes.bool.isRequired,
  eventMaterials: PropTypes.arrayOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        rangeBegin: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        rangeEnd: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        count: PropTypes.number,
      })
    )
  ).isRequired,
  materialTypes: PropTypes.objectOf(
    PropTypes.shape({
      name: PropTypes.string,
    })
  ),
  eventUsedMaterials: PropTypes.objectOf(PropTypes.number),
  tcEventId: PropTypes.number.isRequired,
};

export default MaterialChainEvent;
